$(window).on('load', () => {
  AOS.init({
    offset: jQuery(window).height() * 0.1,
  });
  const header = document.querySelector('header');

  window.addEventListener('scroll', function (e) {
    let scrollPosition = window.scrollY;
    if (+scrollPosition > 80) {
      if (!header.classList.contains('scrolled')) {
        header.classList.add('scrolled');
      }
    } else {
      header.classList.remove('scrolled');
    }
  });

  $('#mainHamburger').on('click', function(e) {
    $('#mobileMenu').toggleClass('active');
    $('#mainHamburger').toggleClass('active');
    $('body').toggleClass('mm-active');
  })

  $('#mobileMenu a').on('click', function() {
    $('#mobileMenu').removeClass('active');
    $('#mainHamburger').removeClass('active');
    $('body').toggleClass('mm-active');
  })
});

$( window ).resize(function() {
  if ($(window).width() > 992) {
    $('#mobileMenu').removeClass('active');
    $('#mainHamburger').removeClass('active');
    $('body').removeClass('mm-active');
  } 
});
